module.exports = __webpack_public_path__ + "static/media/appleStoreIcon.325e74cf.png";